import React from 'react';
import { LuSearch, LuRefreshCw } from 'react-icons/lu';
import './ProductSyncTable.css';

const getThumbnail = (product) =>
  product && product.variants && product.variants[0] && product.variants[0].pictures && product.variants[0].pictures[0]
    ? product.variants[0].pictures[0].url
    : null;

// Busca de produto por código/nome (mínimo de `minLength` caracteres) com
// lista de resultados e botão de sincronização individual por linha.
const ProductSyncTable = ({ term, onTermChange, results, onSync, syncingCode, minLength = 4, disabled = false }) => {
  const showHint = term.trim().length > 0 && term.trim().length < minLength;
  const showEmpty = term.trim().length >= minLength && results.length === 0;

  return (
    <div className="product-sync-table">
      <label className="product-sync-table__label" htmlFor="product-sync-search">
        Sincronize apenas o produto
      </label>
      <div className="product-sync-table__search">
        <LuSearch size={16} className="product-sync-table__search-icon" />
        <input
          id="product-sync-search"
          type="text"
          className="product-sync-table__input"
          placeholder="Buscar por código ou nome do produto"
          value={term}
          onChange={(e) => onTermChange(e.target.value)}
        />
      </div>

      {showHint && (
        <p className="product-sync-table__hint">Digite pelo menos {minLength} caracteres para buscar.</p>
      )}
      {showEmpty && <p className="product-sync-table__hint">Nenhum produto encontrado.</p>}

      {results.length > 0 && (
        <div className="product-sync-table__results">
          <table className="product-sync-table__table">
            <thead>
              <tr>
                <th></th>
                <th>Código</th>
                <th>Nome</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {results.map((product) => {
                const isSyncing = syncingCode === product.code;
                const thumbnail = getThumbnail(product);
                return (
                  <tr key={product.code}>
                    <td className="product-sync-table__thumb-cell">
                      {thumbnail ? (
                        <img src={thumbnail} alt={product.name} className="product-sync-table__thumb" />
                      ) : (
                        <div className="product-sync-table__thumb product-sync-table__thumb--empty" />
                      )}
                    </td>
                    <td className="product-sync-table__code">{product.code}</td>
                    <td>{product.name}</td>
                    <td className="product-sync-table__actions">
                      <button
                        type="button"
                        className="product-sync-table__sync-btn"
                        disabled={Boolean(syncingCode) || disabled}
                        onClick={() => onSync(product)}
                      >
                        <LuRefreshCw size={14} className={isSyncing ? 'is-spinning' : ''} />
                        {isSyncing ? 'Sincronizando...' : 'Sincronizar'}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ProductSyncTable;
